<template>
  <v-navigation-drawer
    v-model="_show"
    app
    clipped
    mini-variant-width="70"
    :mini-variant="expand"
    :expand-on-hover="expand"
    mobile-breakpoint="960"
    :width="300"
  >
    <v-card elevation="0">
      <v-card-text>
        <v-list outlined>
          <v-list-item>
            <v-list-item-title class="text-center">
              <h1>Rendezés</h1>
            </v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-select
                label="Kibocsátó"
                v-model="orders.issuer_id"
                :items="orderValues"
                item-text="title"
                item-value="order"
                v-bind="inputAttributes"
                tabindex="1"
              ></v-select>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-select
                label="Szabályozó típus"
                v-model="orders.regulator_id"
                :items="orderValues"
                item-text="title"
                item-value="order"
                v-bind="inputAttributes"
                tabindex="2"
              ></v-select>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-select
                label="Szám"
                v-model="orders.serial_number"
                :items="orderValues"
                item-text="title"
                item-value="order"
                v-bind="inputAttributes"
                tabindex="3"
              ></v-select>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-select
                label="Dátum"
                v-model="orders.effective_date"
                :items="orderValues"
                item-text="title"
                item-value="order"
                v-bind="inputAttributes"
                tabindex="4"
              ></v-select>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-divider></v-divider>
          </v-list-item>

          <v-list-item>
            <v-list-item-title class="text-center">
              <h1>Kereső</h1>
            </v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-text-field
                label="Dokumentum címe"
                v-model="searchFilters.title"
                v-bind="inputAttributes"
                clearable
                v-on:keyup.enter="SET_FILTERS(searchFilters)"
                @click:append="searchFilters.title = null"
                tabindex="5"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-autocomplete
                label="Kibocsátó"
                v-model="searchFilters.issuer_id"
                :items="issuers"
                item-text="name"
                item-value="id"
                v-bind="inputAttributes"
                clearable
                v-on:keyup.enter="SET_FILTERS(searchFilters)"
                @click:append="searchFilters.issuer_id = null"
                tabindex="6"
              ></v-autocomplete>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-autocomplete
                label="Szabályozó"
                v-model="searchFilters.regulator_id"
                :items="regulators"
                item-text="name"
                item-value="id"
                v-bind="inputAttributes"
                clearable
                v-on:keyup.enter="SET_FILTERS(searchFilters)"
                @click:append="searchFilters.regulator_id = null"
                tabindex="7"
              ></v-autocomplete>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-text-field
                label="Dokumentum száma"
                v-model="searchFilters.serial_number"
                v-bind="inputAttributes"
                clearable
                v-on:keyup.enter="SET_FILTERS(searchFilters)"
                @click:append="searchFilters.serial_number = null"
                tabindex="8"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <YearPicker
                v-model="searchFilters.year"
                label="Évszám"
                :attributes="inputAttributes"
                :tabindex="9"
              />
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <Datepicker
                v-model="searchFilters.effective_date"
                label="Dátum"
                :attributes="inputAttributes"
                :tabindex="10"
              />
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-switch
                v-model="searchFilters.is_archived"
                label="Archív dokumentumok"
              ></v-switch>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-title class="text-center">
              <h4 class="d-inline">Dokumentum szövege</h4>
              <v-btn small icon color="green" @click="addSearchText">
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
            </v-list-item-title>
          </v-list-item>

          <DocumentText
            v-for="(content, index) in searchFilters.content"
            :key="content.key"
            v-model="content.text"
            :input-attributes="{
              ...inputAttributes,
              clearable: index === 0,
              label: `Dokumentum szövege ${index + 1}`,
              appendIcon: index !== 0 ? 'mdi-close' : null
            }"
            @click:append="removeSearchText(index)"
            @enter="SET_FILTERS(searchFilters)"
            :tabindex="50 + index"
          />
        </v-list>

        <v-list>
          <v-list-item>
            <v-list-item-title class="text-center">
              <v-btn
                icon
                large
                @click="searchFilters.relation = !searchFilters.relation"
              >
                <v-icon>
                  {{ _connectionIcon }}
                </v-icon>
              </v-btn>
            </v-list-item-title>
          </v-list-item>
        </v-list>

        <v-list outlined>
          <v-list-item-title class="text-center">
            <h1>Meta adatok</h1>
          </v-list-item-title>

          <v-list-item v-for="meta in metas" :key="meta.id">
            <v-list-item-content>
              <v-text-field
                :tabindex="100 + meta.id"
                :label="meta.name"
                v-model="searchFilters.metas[meta.id]"
                v-bind="inputAttributes"
                clearable
                v-on:keyup.enter="SET_FILTERS(searchFilters)"
                @click:append="searchFilters.metas[meta.id] = null"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <template v-slot:append>
      <v-card elevation="0">
        <v-card-actions class="justify-center">
          <v-btn
            small
            color="primary"
            outlined
            @click="SET_FILTERS(searchFilters)"
            tabindex="200"
          >
            Keresés
          </v-btn>
          <v-btn small color="primary" outlined @click="clearFilters" tabindex="201">
            Törlés
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { SET_FILTERS, SET_ORDERS } from "../../../utils/constants";
import DocumentText from './Filters/DocumentText'
import yearPicker from '../../Pickers/YearPicker'
import Datepicker from '../../Pickers/Datepicker'
import qs from "qs";
import Vue from 'vue'

export default {
  name: "FilterDrawer",
  components:{DocumentText,yearPicker,Datepicker},
  data() {
    return {
      searchFilters: {
        metas: {},
        content: [{ key: "c-0", text: "" }],
        relation: false
      },
      inputAttributes: {
        dense: true,
        clearable: true,
        outlined: true,
        hideDetails: true
      }
    };
  },
  beforeMount() {
    this.getAllIssuers();
    this.getAllMetas();
    this.getAllRegulators();
  },
    mounted() {
      let params = qs.parse(window.location.search,{ ignoreQueryPrefix: true, arrayLimit: 0 })
      if (params.content){
          params.content = Object.values(params.content).map(item=>{return {key:`c-${item}`, text:item}})
      }
        if (params.order && params.order.desc) {
            this[SET_ORDERS]({...this.orders, ...Object.fromEntries(params.order.desc.flat().map(item => [item, "desc"]))})
        }
        if (params.order && params.order.asc) {
            this[SET_ORDERS]({...this.orders, ...Object.fromEntries(params.order.asc.flat().map(item => [item, "asc"]))})
        }
        if (params.issuer_id) {
            params.issuer_id = parseInt(params.issuer_id);
        }
        if (params.regulator_id) {
            params.regulator_id = parseInt(params.regulator_id);
        }
        if (params.year) {
            params.year = parseInt(params.year);
        }
        delete params.order;
      this.searchFilters = { ...this.searchFilters, ...params }
    },
    computed: {
    ...mapGetters("Navigation", ["drawer", "expand"]),
    ...mapGetters("Auth", {
      user: "loggedInUser"
    }),
    ...mapGetters("Table", ["filters", "orders", "orderValues"]),
    ...mapGetters("Meta", ["metas"]),
    ...mapGetters("Issuer", ["issuers"]),
    ...mapGetters("Regulator", ["regulators"]),
    _show: {
      get() {
        return this.drawer;
      },
      set(drawer) {
        if (drawer != this.drawer) {
          this.SET_DRAWER(!this.drawer);
        }
      }
    },
    _connectionIcon() {
      if (!this.searchFilters.relation) {
        return "mdi-link-variant-off";
      }
      return "mdi-link-variant";
    }
  },
  methods: {
    ...mapActions("Issuer", ["getAllIssuers"]),
    ...mapActions("Meta", ["getAllMetas"]),
    ...mapActions("Regulator", ["getAllRegulators"]),
    ...mapMutations("Navigation", ["SET_DRAWER"]),
    ...mapMutations("Table", [SET_FILTERS, SET_ORDERS]),
    clearFilters() {
      this[SET_ORDERS]({ serial_number: 'desc' });
      this[SET_FILTERS]({});
      window.history.pushState('','','?');
      this.searchFilters = {
        metas: {},
        content: [{ key: "c-0", text: "" }],
        relation: false
      };
      this.$set(this.searchFilters,"content",[{ key: "c-0", text: "" }]);
      Vue.set(this.searchFilters.content,0,{ key: "c-0", text: "" });
    },
    addSearchText() {
      const length = this.searchFilters.content.length;
      this.searchFilters.content.push({ key: `c-${length}`, text: "" });
    },
    removeSearchText(index) {
      if (index != 0) {
        const content = [...this.searchFilters.content];

        this.searchFilters.content = content.filter(
          (value, idx) => idx != index
        );
      }
    }
  }
};
</script>
